var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#62BEE7;}\n\t.st1{fill:#474E5E;}\n\t.st2{fill:#F3EEE4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#E8DCCA;}\n\t.st5{opacity:0.1;fill:#231F20;}\n\t.st6{fill:#506268;}\n\t.st7{fill:#EB5151;}\n\t.st8{fill:#C64444;}\n\t.st9{fill:#9CCB5B;}\n\t.st10{fill:#404A4C;}\n\t.st11{fill:#676767;}\n\t.st12{fill:#E0E1E5;}\n\t.st13{fill:#9D9EA0;}\n\t.st14{fill:#B3B4B7;}\n\t.st15{opacity:0.1;}\n\t.st16{fill:#231F20;}\n\t.st17{fill:#FACC20;}\n\t.st18{fill:#FDEF34;}\n\t.st19{fill:#F7A90B;}\n\t.st20{fill:#20B8EA;}\n\t.st21{fill:#00A8EA;}\n\t.st22{fill:#33D3F4;}\n\t.st23{opacity:0.25;fill:#FFFFFF;}\n\t.st24{fill:#CACBCE;}\n\t.st25{fill:#2E3545;}\n\t.st26{fill:#8DAF4A;}\n\t.st27{fill:#F9C2AF;}\n\t.st28{fill:#AFDDF4;}\n\t.st29{fill:#677177;}\n\t.st30{fill:#FFEDB3;}\n\t.st31{fill:#695652;}\n\t.st32{fill:#30A7BF;}\n\t.st33{fill:#4D5556;}\n\t.st34{opacity:0.35;}\n\t.st35{fill:#FFCB04;}\n\t.st36{fill:#99E9FA;}\n\t.st37{opacity:0.2;}\n\t.st38{opacity:3.000000e-02;}\n\t.st39{fill:#9ECA5B;}\n\t.st40{fill:#98BA56;}\n\t.st41{fill:#40EEFF;}\n\t.st42{fill:#FF6A52;}\n\t.st43{opacity:0.1;fill:#FFFFFF;}\n\t.st44{opacity:0.4;}\n\t.st45{fill:#57606D;}\n\t.st46{fill:#BACA5B;}\n\t.st47{opacity:0.25;}\n\t.st48{opacity:5.000000e-02;fill:#231F20;}\n\t.st49{opacity:0.2;fill:#FFFFFF;}\n\t.st50{opacity:0.3;}\n\t.st51{fill:#FFD82F;}\n\t.st52{fill:#F4C121;}\n\t.st53{fill:#EF9D0A;}\n\t.st54{fill:#F9E532;}\n\t.st55{fill:#F4C01E;}\n\t.st56{fill:#FFE14D;}\n\t.st57{fill:#B7C156;}\n\t.st58{fill:#DBA92C;}\n\t.st59{fill:#363D4D;}\n\t.st60{fill:#3F4656;}\n\t.st61{fill:#463E33;}\n\t.st62{fill:none;}\n\t.st63{opacity:4.000000e-02;}\n\t.st64{fill:#4DB6AC;}\n\t.st65{fill:#CADE49;}\n\t.st66{fill:#9FD343;}\n\t.st67{fill:#AAD643;}\n\t.st68{fill:#82C736;}\n\t.st69{opacity:0.3;fill:#FFFFFF;}\n\t.st70{fill:#FFD640;}\n\t.st71{opacity:0.5;}\n\t.st72{opacity:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.7,12.7 18.1,24.2 18.1,56 50.6,56 50.6,12.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 41.3,
    cy: 21.2,
    r: 5.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "29.7,24.2 29.7,12.7 18.1,24.2    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    height: 17.1,
    width: 24.8,
    x: 21.9,
    y: 29.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 4.6,
    width: 3.1,
    x: 25.8,
    y: 39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 7.7,
    width: 3.1,
    x: 32.8,
    y: 35.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 10.9,
    width: 3.1,
    x: 39.7,
    y: 32.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "18.1,24.2 29.7,12.7 45.9,12.7 45.9,8 13.4,8 13.4,51.3 18.1,51.3    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M30.5,50.6h-8.5c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h8.5c0.4,0,0.8,0.3,0.8,0.8     C31.2,50.2,30.9,50.6,30.5,50.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M30.5,53.7h-8.5c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h8.5c0.4,0,0.8,0.3,0.8,0.8     C31.2,53.3,30.9,53.7,30.5,53.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M46.7,50.6h-8.5c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h8.5c0.4,0,0.8,0.3,0.8,0.8     C47.5,50.2,47.1,50.6,46.7,50.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M46.7,53.7h-8.5c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h8.5c0.4,0,0.8,0.3,0.8,0.8     C47.5,53.3,47.1,53.7,46.7,53.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M43.2,21.7c-0.1-0.2-0.3-0.8-1.6-1v-1.6c0.3,0.1,0.5,0.3,0.6,0.6c0.1,0.3,0.2,0.4,0.5,0.4     c0.1,0,0.9-0.2,0.1-1.2c-0.1-0.2-0.4-0.5-1.2-0.5v-0.6h-0.5v0.6c-1.5,0.2-1.6,1.1-1.6,1.5c0,1.3,1.3,1.5,1.6,1.6v1.8     c-0.6-0.1-0.7-0.8-0.8-1c-0.1-0.3-0.3-0.3-0.5-0.3c-0.4,0-0.5,0.4-0.5,0.5c0,0.2,0.1,0.9,1,1.4c0.2,0.1,0.5,0.2,0.8,0.2l0,0.6     h0.5V24c0.4,0,0.7-0.1,0.9-0.3C43.2,23.3,43.4,22.5,43.2,21.7z M41.1,20.5c-0.4-0.2-0.7-0.2-0.7-0.7c0-0.2,0.1-0.6,0.7-0.7V20.5z      M41.6,23.3v-1.7c0.8,0.3,0.8,0.6,0.8,0.8C42.3,22.6,42.3,23.1,41.6,23.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales_icon.88b1f65f8ba4e49479c630223b9abb95.svg";
export { ForwardRef as ReactComponent };